
		import workerPath from "omt:/usr/app/packages/client/src/app/tokenizationWorker.js?comlink";
		import {wrap} from "comlink";

		export default wrap(new Worker(new URL(workerPath, import.meta.url)));
	